import previmedical from "../../assets/providers/1.png";
import blueAssistance from "../../assets/providers/2.png";
import aon from "../../assets/providers/aon.png"
import caspie from "../../assets/providers/caspie-logo.png"
import marsh from "../../assets/providers/marsh.png"
import insalute from "../../assets/providers/insalute.png"
import poste from "../../assets/providers/posteassicura.png"
import postewelfare from "../../assets/providers/postewelfare.png"
import generali from "../../assets/providers/logo-generali.png"
import faschim from "../../assets/providers/faschim.png"
import aster from "../../assets/providers/aster.png"
import asem from "../../assets/providers/asem.png"
import assida from "../../assets/providers/assida.png"
import cadiprof from "../../assets/providers/cadiprof.png"
import casagit from "../../assets/providers/casagit.png"
import cesarepozzo from "../../assets/providers/cesarepozzo.png"
import consorziomusa from "../../assets/providers/consorziomusa.png"
import cooperazionesalute from "../../assets/providers/cooperazionesalute.png"
import entemutuo from "../../assets/providers/entemutuo.png"
import fasdac from "../../assets/providers/fasdac.png"
import fasie from "../../assets/providers/fasie.png"
import fasiv from "../../assets/providers/fasiv.png"
import fisde from "../../assets/providers/fisde.png"
import fondoest from "../../assets/providers/fondoest.png"
import mba from "../../assets/providers/mba.png"
import quas from "../../assets/providers/quas.png"
import salutesempre from "../../assets/providers/salutesempre.png"
import sanarti from "../../assets/providers/sanarti.png"
import sanimoda from "../../assets/providers/sanimoda.png"


import {InsuranceProviderIntegrationCodes} from "../../models/InsuranceProvider";

export function getLogoFromIntegrationCode(integrationCode: string) {
    switch (integrationCode) {
        case InsuranceProviderIntegrationCodes.PREVIMEDICAL:
            return previmedical;
        case InsuranceProviderIntegrationCodes.BLUEASSISTANCE:
            return blueAssistance;
        case InsuranceProviderIntegrationCodes.AON:
            return aon;
        case InsuranceProviderIntegrationCodes.CASPIE:
            return caspie;
        case InsuranceProviderIntegrationCodes.MARSH:
            return marsh;
        case InsuranceProviderIntegrationCodes.INSALUTE:
            return insalute;
        case InsuranceProviderIntegrationCodes.GRUPPOGENERALI:
        case InsuranceProviderIntegrationCodes.GENERALI:
            return generali;
        case InsuranceProviderIntegrationCodes.POSTE:
            return poste;
        case InsuranceProviderIntegrationCodes.POSTEWELFARE:
            return postewelfare;
        case InsuranceProviderIntegrationCodes.FASCHIM:
            return faschim;
        case InsuranceProviderIntegrationCodes.ASTER:
            return aster;
        case InsuranceProviderIntegrationCodes.ASEM:
            return asem;
        case InsuranceProviderIntegrationCodes.ASSIDA:
            return assida;
        case InsuranceProviderIntegrationCodes.CADIPROF:
            return cadiprof;
        case InsuranceProviderIntegrationCodes.CASAGIT:
            return casagit;
        case InsuranceProviderIntegrationCodes.CESAREPOZZO:
            return cesarepozzo;
        case InsuranceProviderIntegrationCodes.CONSORZIOMUSA:
            return consorziomusa;
        case InsuranceProviderIntegrationCodes.COOPERAZIONESALUTE:
            return cooperazionesalute;
        case InsuranceProviderIntegrationCodes.ENTEMUTUOREGIONALE:
            return entemutuo;
        case InsuranceProviderIntegrationCodes.FASDAC:
            return fasdac;
        case InsuranceProviderIntegrationCodes.FASIE:
            return fasie;
        case InsuranceProviderIntegrationCodes.FASIV:
            return fasiv;
        case InsuranceProviderIntegrationCodes.FISDE:
            return fisde;
        case InsuranceProviderIntegrationCodes.FONDOEST:
            return fondoest;
        case InsuranceProviderIntegrationCodes.MUTUAMBA:
            return mba;
        case InsuranceProviderIntegrationCodes.QUAS:
            return quas;
        case InsuranceProviderIntegrationCodes.SALUTESEMPRE:
            return salutesempre;
        case InsuranceProviderIntegrationCodes.SANARTI:
            return sanarti;
        case InsuranceProviderIntegrationCodes.SANIMODA:
            return sanimoda;
        default:
            return "";
    }
}
